import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_LAST_TASK } from "./actionTypes";
import { getLastTaskSuccess, getLastTaskError } from "./actions";

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

function* getLastTask({ payload: { user } }) {
  try {
    const response = yield call(tasksAPI.getLastTask, user.token);
    yield put(getLastTaskSuccess(response.lastTask, response.message));
  } catch (error) {
    yield put(getLastTaskError(error));
  }
}

export function* watchGetTasks() {
  yield takeEvery(GET_LAST_TASK, getLastTask);
}

function* getLastTaskSaga() {
  yield all([fork(watchGetTasks)]);
}

export default getLastTaskSaga;
